import Vue from "vue";
import VueI18n from "vue-i18n";
import getLocale from "@/utils/locale";
import CookieBanner from "./components/cookie-banner";
import store from "@/store";
import globals from "@/utils/globals";

import { consent, consentAll } from "@/services/cookiebot";

Vue.use(VueI18n);

const init = () => {
  const container = document.querySelector(".vue-cookie-banner");

  if (!container) {
    return;
  }

  if (globals.autoCookieConsent) {
    if (window.Cookiebot && window.Cookiebot.submitCustomConsent) {
      window.Cookiebot.submitCustomConsent(false, false, false);
    }

    return;
  }

  initBanner(container);
};

const initBanner = (el) => {
  new Vue({
    name: "CookieBannerInit",
    el,
    components: {
      CookieBanner
    },
    store,
    i18n: new VueI18n({ locale: getLocale() }),
    render: h => h(CookieBanner, {
      on: {
        consent: (options) => {
          consent(options);
        },
        "consent-all": () => {
          consentAll();
        }
      }
    })
  });
};

export default init;
